export default __webpack_public_path__ + "static/media/KarunaWielenga.d2b30cea.png";